<div class="container-fluid">
    <div [innerHTML]="body"></div>
    <br>
    <p-button (click)="close('success')">{{buttonText}}</p-button>
</div>